import { render, staticRenderFns } from "./weighing-scale.vue?vue&type=template&id=3580eee2"
import script from "./weighing-scale.vue?vue&type=script&lang=js"
export * from "./weighing-scale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports